import React from 'react';
import { CategoriesColorsEnum } from 'constants/categories-colors';
import classes from './ColoredCategory.module.scss';
import { GetCategoriesQuery } from '../../../../models/graphql';
import { Badge } from 'components/containers/Badge';
import { BadgeColorsEnum, BadgeSizesEnum } from 'constants/badge';

export type CategoryBadge = 'outOfSeason' | 'inSeason';

export type ColoredCategoryViewProps = {
  category: GetCategoriesQuery['workspace']['categories'][number];
};

export const ColoredCategoryView = ({
  category: { color, name, seasonal, seasonallyPaused }
}: ColoredCategoryViewProps): JSX.Element => {
  const SeasonalBadge = () => {
    if (!seasonal) return null;
    const isInSeason = !seasonallyPaused;

    if (isInSeason) {
      return <Badge color={BadgeColorsEnum.GREEN15} size={BadgeSizesEnum.LARGE} text={'Active In Season'} />;
    }

    return <Badge color={BadgeColorsEnum.GREY20} size={BadgeSizesEnum.LARGE} text={'Out of Season'} />;
  };

  return (
    <div className={'grid-x align-middle'}>
      <div className={`cell ${classes.Line}`} style={{ backgroundColor: CategoriesColorsEnum[color] }} />
      <h3 className={`cell auto ${classes.Name}`}>{name}</h3>
      <SeasonalBadge />
    </div>
  );
};
